module.exports = {
        srcSet: __webpack_public_path__ + "static/media/document-400.23763756.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/document-400.23763756.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/document-400.23763756.webp",
        toString: function(){return __webpack_public_path__ + "static/media/document-400.23763756.webp"},
        
        width: 400,
        height: 400
      }